//user.actions.js
import axios from "axios"
import { useNavigate } from "react-router-dom"

function getUser(){
    const user = JSON.parse(localStorage.getItem("user"))
    return user
}

function getAccessToken(){/* 
    const auth = JSON.parse(localStorage.getItem("auth")) */
    const access = localStorage.getItem("access")
    return access
}

function getRefreshToken(){/*
    const auth = JSON.parse(localStorage.getItem("auth")) */
    const refresh = localStorage.getItem("refresh")
    return refresh
}

function setUserData(data){
    localStorage.setItem(
        "auth",
        JSON.stringify(data))
    localStorage.setItem(
        "user",
        JSON.stringify(data.user))
    localStorage.setItem(
        "access",
        data.access)
    localStorage.setItem(
        "refresh",
        data.refresh)
}
export { getAccessToken, getRefreshToken, getUser }

export function useUserActions(){
    const navigate = useNavigate()
    const baseUrl = "https://beatsapi.ilemlembo.me/api"
    
    function login(data){
        return axios.post(`${baseUrl}/auth/login/`, data)
            .then((res) => {
                setUserData(res.data)
                navigate("/dashboard")
            })
    }

    function logout(){
        localStorage.removeItem("auth");
        localStorage.removeItem("user");
        localStorage.removeItem("access");
        localStorage.removeItem("refresh");
        navigate("/login")
    }

    return {
        login,
        logout,
    }
}
